import {
  Component,
  OnInit,
  Input,
  ViewEncapsulation,
  HostListener,
  ElementRef,
  ViewChild,
  Renderer2,
} from '@angular/core';
import { InboxJobsService } from '../../services';
import { MapService } from '../../services';
import { InputHelper } from '../../utils/input.helper';

import { MessageService } from 'primeng';
import { IJobDeploymentInfo } from '../../interfaces/job-deployment';

@Component({
  selector: 'job-deployment-details',
  styleUrls: ['./job-deployment-details.component.scss'],
  templateUrl: './job-deployment-details.component.html',
  encapsulation: ViewEncapsulation.None, // todo: check why
})
export class JobDeploymentDetailsComponent implements OnInit {
  public organisationTypeId = 1;

  // Binding properties
  @Input('jobInfo')
  public set jobInfo(value: IJobDeploymentInfo) {
    this._jobInfo = value;
  }

  public get jobInfo(): IJobDeploymentInfo {
    return this._jobInfo;
  }

  private _jobInfo: IJobDeploymentInfo;
  showSupplierPremiums: boolean;
  showCustomerPremiums: boolean;

  @ViewChild('jobOverview') jobOverview: ElementRef;

  @ViewChild('taskDetails') taskDetails: ElementRef;

  private readonly _yAxisToScroll = 600;

  constructor(
    private renderer: Renderer2,
    public messageService: MessageService,
    public inputHelper: InputHelper,
    public inboxjobsService: InboxJobsService,
    public mapService: MapService,
  ) {}

  ngOnInit() {}

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    this.scrollJobOverviewAndTaskDetails(
      window.scrollY > this._yAxisToScroll ? window.scrollY - 100 : 0,
    );
  }

  private scrollJobOverviewAndTaskDetails(yAxis: number) {
    this.renderer.setStyle(this.jobOverview.nativeElement, 'top', `${yAxis}px`);
    this.renderer.setStyle(this.taskDetails.nativeElement, 'top', `${yAxis}px`);
  }
}
